<script lang="ts" module>
	const toaster = Toaster();
	// export const addToast = helpers.addToast;
	export const addToast = (data: ToastData) => {
		toaster.toast(data);
	};
</script>

<script lang="ts">
	import { getFlash } from 'sveltekit-flash-message';
	import { page } from '$app/state';
	import { browser } from '$app/env';
	import { onDestroy } from 'svelte';
	import { Toaster } from '#lib/common/Presentation/Toast/ToasterFactory.js';
	import type { ToastData } from '#lib/common/Presentation/Toast/ToastServiceInterface.js';

	const flash = getFlash(page);

	const unsubscribe = flash.subscribe((value) => {
		if (value && browser) {
			addToast({
				title: value.title,
				description: value?.message,
				intent: value.type === 'error' ? 'error' : 'success'
			});
			flash.set(undefined);
		}
	});

	onDestroy(unsubscribe);
</script>
